module.exports = __webpack_public_path__ + "img/icon-cognitives-science.28a125b3.png";